import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  list: {
    marginTop: 16,
    background: 'white',
    padding: 16,
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    width: '100%',
  },

  notFound: {
    textAlign: 'center',
    padding: '24px 0',
  },

  buttonViewMore: {
    fontSize: 32,
  },

  iconMenu: {
    fontSize: 16,
    marginRight: 8,
  },

  copy: {
    display: 'flex',
    alignItems: 'center',

    '& span.material-icons': {
      fontSize: 16,
      marginLeft: 8,
      cursor: 'pointer',
    },
  },
}));

export default styles;
